module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQAAAADsdIMmAAAAGElEQVR4nGN4zsTAtIlJi4mB4T8TAxMDABwYAs8lszcDAAAAAElFTkSuQmCC"